<template>
  <el-card>
    <el-table ref="table" class="global-table" stripe v-loading="loading" :data="tableData" max-height="550px">
      <el-table-column label="年月" prop="planYm" show-overflow-tooltip></el-table-column>
      <el-table-column label="营收计划（元）" prop="planRevenueAmount" show-overflow-tooltip></el-table-column>
      <el-table-column label="人工成本计划（元）" prop="planPersonCostAmount" show-overflow-tooltip></el-table-column>
      <el-table-column label="机械成本计划（元）" prop="planMachineCostAmount" show-overflow-tooltip></el-table-column>
      <el-table-column label="材料成本计划（元）" prop="planMaterialCostAmount" show-overflow-tooltip></el-table-column>
      <el-table-column label="间接费计划（元）" prop="planIndirectAmount" show-overflow-tooltip></el-table-column>
      <el-table-column label="计划利润（元）" prop="planProfitAmount" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="180px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onEdit(row)">编辑</el-button>
          <el-button type="text" @click="onDelete(row.detailId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <global-pagination :total="total" :current-page.sync="page" :page-size.sync="size" @current-change="loadData"
      @size-change="loadData"></global-pagination>

    <el-dialog :visible.sync="dialogVisible" title="编辑">
      <el-form class="global-form2" :model="formData" ref="form" :rules="rules" label-width="140px">
        <el-form-item label="项目名称" prop="projectId">
          <el-select disabled v-model="formData.projectId" placeholder="请选择所属项目">
            <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName" :value="item.projectId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="endDate" label="年月">
          <el-date-picker disabled v-model="formData.planYm" value-format="yyyy-MM" type="month" placeholder="年月"></el-date-picker>
        </el-form-item>
        <el-form-item prop="planRevenueAmount" label="营收计划（元）">
          <el-input disabled v-model="formData.planRevenueAmount" placeholder="营收计划"></el-input> 元
        </el-form-item>
        <el-form-item prop="planPersonCostAmount" label="人工成本计划（元）">
          <el-input v-model="formData.planPersonCostAmount" placeholder="请输入"></el-input> 元
        </el-form-item>
        <el-form-item prop="planMachineCostAmount" label="机械成本计划（元）">
          <el-input v-model="formData.planMachineCostAmount" placeholder="请输入"></el-input> 元
        </el-form-item>
        <el-form-item prop="planMaterialCostAmount" label="材料成本计划（元）">
          <el-input v-model="formData.planMaterialCostAmount" placeholder="请输入"></el-input> 元
        </el-form-item>
        <el-form-item prop="planIndirectAmount" label="间接费计划（元）">
          <el-input v-model="formData.planIndirectAmount" placeholder="请输入"></el-input> 元
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-card>
</template>

<script>
import { deepClone } from '@/utils/util';

export default {
  name: "CostPlanningDetails",
  data() {
    return {
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      tableData: [],
      formData: {
        detailId: '', // 成本计划明细ID
        planPersonCostAmount: '', // 人工计划成本金额
        planMachineCostAmount: '', // 机械计划成本金额
        planMaterialCostAmount: '', // 材料计划成本金额
        planIndirectAmount: '', // 间接计划金额
        planProfitAmount: '' // 利润计划金额
      },
      dialogVisible: false,
      rules: {
        projectId: [
          { required: true, message: '请选择项目名称' }
        ],
        contractId: [
          { required: true, message: '请选择养护合同' }
        ]
      }
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    },
    planCostId() {
      return this.$route.query.planCostId
    }
  },
  watch: {},
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.operate.selectPlanCostDetailByPage, {
        page: this.page,
        size: this.size,
        planCostId: this.planCostId
      }).then((res) => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onEdit(row) {
      this.formData = deepClone(row)
      this.dialogVisible = true
    },
    onDelete(detailId) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.operate.deletePlanCostDetail, { detailId }).then(() => {
          this.$message.success('删除成功')
          this.onSearch()
        })
      })
    },
    onSubmit() {
      this.$refs.form.validate().then(() => {
        this.$axios.post(this.$apis.operate.updatePlanCostDetail, this.formData).then(() => {
          this.$message.success('提交成功')
          this.dialogVisible = false
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
